import React from 'react';
import invariant from 'tiny-invariant';
import PricingRulesContext from '../PricingRulesProvider/PricingRulesContext';
export default function useEffectPricingRules(handler) {
  var ctx = React.useContext(PricingRulesContext);
  invariant(ctx, "Don't use 'useEffectPricingRules' outside of <PricingRulesProvider>");
  var rules = ctx.rules;
  React.useEffect(function () {
    handler();
  }, [rules]); // eslint-disable-line react-hooks/exhaustive-deps
}